import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

import Layout from "../../Component/Layout";

import { TILE_REGISTRY } from "../../Component/Favourite/TileRegistry";

import PinToHome from "../../Component/Favourite/PinToHome";
import { FileText } from 'lucide-react';
import { authHeaders } from "../../utils/authHeaders";
import { MASTER_API } from "../../apiConfig";


const USER_MANUAL_SCOPE = {
    moduleName: "Logistics",
    process: "Inventory Management",
    subProcess: ""
};
const USER_MANUAL_LIST_API = `${MASTER_API}/user-manual/list`;

function Inventory() {
    // 🔴 Registry se sirf "Inventory" wali tiles filter kar rahe hain
    const cards = Object.values(TILE_REGISTRY).filter(t => t.moduleName === "Inventory");
    const navigate = useNavigate();

    const [showManual, setShowManual] = useState(false);
    const [manualExists, setManualExists] = useState(null);
    const [manualFile, setManualFile] = useState(null);

   const handleNavigate = (path) => {
    if (path) navigate(path);
};

    return (
        <Layout>
            <div style={{ padding: "30px 40px", backgroundColor: "#f8fafc", minHeight: "calc(100vh - 60px)" }}>

                {/* --- Page Header --- */}
                <div style={{
                    marginBottom: "35px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                }}>
                    <div>
                        <h2 style={{ margin: "0 0 8px 0", color: "#0f172a", fontWeight: "700", fontSize: "28px" }}>
                            Inventory
                        </h2>
                        <p style={{ color: "#64748b", margin: 0, fontSize: "15px" }}>
                            Manage your stock levels and warehouse inventory.
                        </p>
                    </div>
                    {/* --- User Manual Icon Button --- */}
                    {/* <button
                        onClick={() => {
                            setManualExists(null);
                            setManualFile(null);
                            setShowManual(true);
                            fetch(USER_MANUAL_LIST_API, { headers: authHeaders() })
                                .then((res) => res.json())
                                .then((data) => {
                                    const norm = (v) => String(v || "").trim().toLowerCase();
                                    const match = (data?.data || []).find((m) =>
                                        norm(m.module_name) === norm(USER_MANUAL_SCOPE.moduleName) &&
                                        norm(m.process_name) === norm(USER_MANUAL_SCOPE.process) &&
                                        norm(m.sub_process_name) === norm(USER_MANUAL_SCOPE.subProcess)
                                    );
                                    if (match && match.drive_link) {
                                        setManualFile(match);
                                        setManualExists(true);
                                    } else {
                                        setManualExists(false);
                                    }
                                })
                                .catch(() => setManualExists(false));
                        }}
                        title="View User Manual"
                        style={{
                            background: "#ffffff",
                            border: "1px solid #e2e8f0",
                            borderRadius: "10px",
                            padding: "10px 14px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            cursor: "pointer",
                            color: "#3b82f6",
                            fontSize: "14px",
                            fontWeight: "600",
                            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#3b82f6"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; }}
                    >
                        <FileText size={18} />
                        User Manual
                    </button> */}
                </div>

                {/* --- User Manual Popup Modal --- */}
                {showManual && (
                    <div
                        onClick={() => setShowManual(false)}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(15, 23, 42, 0.6)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1000,
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: "#ffffff",
                                borderRadius: "12px",
                                width: "90vw",
                                height: "97vh",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                                boxShadow: "0 20px 25px -5px rgba(0,0,0,0.2)",
                            }}
                        >
                            {/* Modal Header */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "14px 20px",
                                    borderBottom: "1px solid #e2e8f0",
                                }}
                            >
                                <h4 style={{ margin: 0, color: "#0f172a", fontSize: "16px", fontWeight: "600" }}>
                                    User Manual
                                </h4>
                                <button
                                    onClick={() => setShowManual(false)}
                                    style={{
                                        border: "none",
                                        background: "#f1f5f9",
                                        borderRadius: "8px",
                                        width: "32px",
                                        height: "32px",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: "#475569",
                                        lineHeight: 1,
                                    }}
                                    title="Close"
                                >
                                    ×
                                </button>
                            </div>

                            {/* PDF Viewer / Fallback */}
                            {manualExists === null && (
                                <div style={{
                                    flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
                                    color: "#94a3b8", fontSize: "14px"
                                }}>
                                    Checking for user manual...
                                </div>
                            )}

                            {manualExists === false && (
                                <div style={{
                                    flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                                    color: "#64748b", gap: "10px", padding: "20px", textAlign: "center"
                                }}>
                                    <FileText size={40} color="#cbd5e1" />
                                    <div style={{ fontSize: "15px", fontWeight: 600, color: "#334155" }}>
                                        User Manual Not Available
                                    </div>
                                    <div style={{ fontSize: "13px", color: "#94a3b8", maxWidth: "320px" }}>
                                        The user manual for this module hasn't been uploaded yet. Please check back later or contact your administrator.
                                    </div>
                                </div>
                            )}

                            {manualExists === true && manualFile && (() => {
                                const MANUAL_SCALE = 1.25;
                                return (
                                    <div style={{ flex: 1, overflow: "hidden", position: "relative" }}>
                                        <iframe
                                            src={manualFile.drive_link.replace("/view", "/preview")}
                                            title={manualFile.file_name || "User Manual"}
                                            allow="autoplay"
                                            style={{
                                                border: "none",
                                                width: `${100 / MANUAL_SCALE}%`,
                                                height: `${100 / MANUAL_SCALE}%`,
                                                transform: `scale(${MANUAL_SCALE})`,
                                                transformOrigin: "top left",
                                            }}
                                        />
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                )}

                {/* --- Tiles Grid --- */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                        gap: "24px",
                    }}
                >
                    {cards.map((item, i) => {
                        const IconComponent = item.icon; 

                        return (
                            <div
                                key={item.id}
                                style={{
                                    background: "#ffffff", 
                                    borderRadius: "16px", 
                                    border: "1px solid #e2e8f0",
                                    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)",
                                    padding: "24px", 
                                    cursor: "pointer", 
                                    position: "relative",
                                    display: "flex", 
                                    flexDirection: "column",
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    height: "160px"
                                }}
                                onClick={() => handleNavigate(item.path)}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-6px)";
                                    e.currentTarget.style.boxShadow = "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)";
                                    e.currentTarget.style.borderColor = "#cbd5e1";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)";
                                    e.currentTarget.style.borderColor = "#e2e8f0";
                                }}
                            >
                                {/* Top Row: Icon + Pin Button */}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "auto" }}>
                                    {/* Tinted Icon Box */}
                                    <div style={{ 
                                        background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)", 
                                        color: "#3b82f6", 
                                        padding: "14px", 
                                        borderRadius: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <IconComponent size={26} />
                                    </div>
                                    
                                    {/* Pin Button */}
                                    <div style={{ position: "relative", zIndex: 10, marginTop: "-5px", marginRight: "-5px" }}>
                                        <PinToHome tileId={item.id} />
                                    </div>
                                </div>

                                {/* Bottom Row: Text */}
                                <div>
                                    <h5 style={{ fontSize: "16px", fontWeight: "600", color: "#0f172a", margin: "0 0 6px 0" }}>
                                        {item.name}
                                    </h5>
                                    <p style={{ fontSize: "13px", color: "#64748b", margin: 0, fontWeight: "500" }}>
                                        Open Module <span style={{ marginLeft: "4px", fontSize: "14px" }}>→</span>
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Layout>
    );
}

export default Inventory;